import get from "lodash.get";
import XHTTP from "services/api/xhttp";

class AbstractApi {
  config = {}; // config object (ex: containing the paths configuration)

  constructor(config) {
    this.config = config;
  }

  retrieveList = (filters = {}) => {
    return XHTTP(get(this.config, "paths.default", ""), {
      method: "post",
      body: JSON.stringify(filters),
    });
  };

  retrieveListByRadius = (filters = {}) => {
    return XHTTP(
      get(this.config, "paths.byRadius", get(this.config, "paths.default", "")),
      {
        method: "post",
        body: JSON.stringify(filters),
      }
    );
  };

  retrieveListByAreas = (filters = {}) => {
    return XHTTP(
      get(this.config, "paths.byAreas", get(this.config, "paths.default", "")),
      {
        method: "post",
        body: JSON.stringify(filters),
      }
    );
  };
}

export default AbstractApi;
